import CancelIcon from "@mui/icons-material/Cancel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ReplyIcon from "@mui/icons-material/Reply";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Stack from "@mui/material/Stack";
import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { SendMessageRequest } from "../../models/chat.model";
import { DeleteMessage, SendMessage } from "../../services/chat.service";

import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { Mention, MentionsInput } from "react-mentions";
import { v4 } from "uuid";
import DropzoneCommentReply from "../../components/dropzone/DropzoneCommentReply";

interface Props {
  referenceKey: string;
  messageKey: string;
  isCopied: boolean;
  canBeDeleted: boolean;
  refMessageKey: string;
  mentionUsers: any;
  message: string;
  userTitle: string | undefined;
  avatarGender: string;
  isSender: boolean;
  setRefreshOnDel: any;
  setRefreshOnSendCap: any;
  replyFiles: any;
  handleCopyMassage: () => void;
}

export default function ChatMenu({
  referenceKey,
  messageKey,
  handleCopyMassage,
  isCopied,
  canBeDeleted,
  message,
  userTitle,
  refMessageKey,
  mentionUsers,
  isSender,
  setRefreshOnDel,
  avatarGender,
  setRefreshOnSendCap,
  replyFiles,
}: Props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [isDelete, setDelete] = useState(false);
  const [reply, setReply] = useState(false);
  const [comment, setComment] = useState("");
  // const [mentionedUserIds, setMentionedUserIds] = useState<number[]>([]);
  const [files, setFiles] = useState<any>();
  const [attachmentDrawer, setAttachmentDrawer] = useState(false);
  const [isTyping, setTyping] = useState(false);
  const [Thunmbnail, setThunmbnail] = useState<any>();
  const fileReplyInput = useRef<HTMLInputElement>(null);

  const mentionPattern = /\@(.*?)\)/gi;

  const { mutate: DeleteMessageMutation } = useMutation(DeleteMessage, {
    onSuccess: (data: boolean) => {
      if (data) {
        setDelete(data);

        if (data) toast.success("پیام پاک شد");
        setRefreshOnDel(v4());
      }
    },
    onError: () => {},
  });

  const { mutate: SendMessageMutation } = useMutation(SendMessage, {
    onSuccess: (data: boolean) => {
      setRefreshOnSendCap(v4());
    },
    onError: () => {},
  });

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  function handleOnImageChoosed(files: any) {
    setThunmbnail(files);
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const openInNewTab = (url: any) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const handleDeleteMessage = () => {
    DeleteMessageMutation({
      referenceKey: referenceKey,
      messageKey: messageKey,
    });

    setOpen(false);
  };

  const handleReply = () => {
    setReply(true);
    setOpen(false);
  };

  const handleSendMessage = () => {
    if (true) {
      const newMessage = {} as SendMessageRequest;
      if (mentionPattern.test(comment)) {
        let desiredText = comment.replace(mentionPattern, "");
        let mentionedIds;
        let mentioned: any = [];
        const mentionedSet = new Set();
        let mentionedUserIds: any = [];

        while ((mentionedIds = mentionPattern.exec(comment)) !== null) {
          mentioned.push(mentionedIds[0]);
        }

        mentioned.map((item: any) => {
          mentionedSet.add(Number(item.split("(")[1].split("/")[0]));
        });

        mentionedSet.forEach((value, valueAgain, set) => {
          mentionedUserIds.push(value);
        });
        if (mentionedUserIds) {
          newMessage.mentionedUserIds = mentionedUserIds;
        }
        if (desiredText === "") {
          desiredText = " ";
        }
        newMessage.messageText = desiredText;
      } else {
        newMessage.messageText = comment;
      }

      newMessage.referrerMessageKey = messageKey;
      newMessage.referenceKey = referenceKey;

      newMessage.files = Thunmbnail;
      SendMessageMutation(newMessage);
      setComment("");
      setReply(false);
      setTyping(false);
    }
  };

  return (
    <>
      <Stack direction="row" spacing={2}>
        <div>
          <Button
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <MoreVertIcon sx={{ color: "#fff" }} />
          </Button>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                  background: "#00102E",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px !important",
                }}
                className="chatMenu"
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      // onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        onClick={handleReply}
                        sx={{ marginBottom: "5px" }}
                      >
                        <ReplyIcon />
                        &nbsp; پاسخ&nbsp;&nbsp;&nbsp;
                      </MenuItem>

                      <MenuItem
                        sx={{ marginBottom: "5px" }}
                        onClick={() => {
                          handleCopyMassage();
                          setOpen(false);
                        }}
                      >
                        <ContentCopyIcon />
                        &nbsp; کپی &nbsp;&nbsp;&nbsp;
                      </MenuItem>

                      {canBeDeleted && (
                        <MenuItem
                          sx={{ marginTop: "5px", paddingTop: "10px" }}
                          onClick={handleDeleteMessage}
                          className="chatMenuLast"
                        >
                          <DeleteOutlineOutlinedIcon /> &nbsp;
                          حذف&nbsp;&nbsp;&nbsp;
                        </MenuItem>
                      )}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Stack>
      {reply && (
        <div
          className="reply-container"
          style={{
            background: "transparent",

            margin: "0px 2px",
            position: "fixed",
            bottom: 0,
            left: 0,
            zIndex: 1010,
            borderCollapse: "separate",
            borderRadius: "5px",
          }}
        >
          <Grid
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ background: "#00102E" }}
            borderRadius={"5px"}
          >
            <Grid
              item
              xs={8}
              width={"100%"}
              minHeight={"180px"}
              paddingX={"1rem"}
            >
              <Grid
                container
                alignItems={"center"}
                sx={{
                  background: "#00102E",
                  width: "100%",
                  minHeight: "180px",
                  borderRadius: "5px",
                  zIndex: 111,
                  // marginBottom: "-5px",
                  position: "relative",
                  paddingY: "1rem",
                }}
              >
                <Grid item sx={{ width: "100%", textAlign: "left" }}>
                  <Typography
                    marginLeft={"10px"}
                    marginBottom={"10px"}
                    onClick={() => setReply(false)}
                  >
                    <CancelIcon
                      sx={{ color: "#fff", fontSize: "32px" }}
                      onClick={() => setThunmbnail("")}
                    />
                  </Typography>
                </Grid>
                <Grid item height={"100px"} width={"100%"} paddingX={"1rem"}>
                  <Box
                    sx={{
                      height: "100%",
                      background: "#34495E",
                      borderRadius: "5px",
                      boxShadow: "inset -7px 10px 0px -5px #9AAFC4;",
                      width: "100%",
                      padding: "1rem 1rem",
                    }}
                    className={isSender ? "resiverStyle" : "senderStyle"}
                  >
                    <Grid
                      container
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Grid item>
                        <Typography
                          sx={{
                            color: "#fff",
                            fontWeight: "bold",
                            textAlign: "right",

                            margin: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              paddingRight: "0px !important",
                            }}
                          >
                            <Avatar
                              // className="chat-card-avatar"
                              sx={{
                                bgcolor: "E5E1DA",
                                marginLeft: "7px",
                                height: "24px",
                                width: "24px",
                              }}
                              aria-label="recipe"
                            >
                              {avatarGender.toLocaleLowerCase() === "female" ? (
                                <img
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  src="images/person_3_black_24dp.svg"
                                  alt="female user"
                                />
                              ) : (
                                <img
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  src="images/person_black_24dp.svg"
                                  alt="male user"
                                />
                              )}
                            </Avatar>
                            {userTitle}
                          </div>
                        </Typography>
                        <Typography
                          sx={{
                            color: "#fff",
                            textAlign: "right",
                            margin: "10px 10px",
                          }}
                        >
                          {message !== null && message.length > 50
                            ? message.substring(0, 50) + "..."
                            : message}
                        </Typography>
                      </Grid>
                      <Grid item>
                        {replyFiles.map((file: any) =>
                          file.fileType === "Image" ? (
                            <img
                              src={
                                file.thumbnailFileUrl !== null
                                  ? file.thumbnailFileUrl
                                  : file.fileUrl
                              }
                              alt={file.fileName}
                              style={{
                                width: "70px",
                                height: "50px",
                                objectFit: "contain",
                              }}
                            />
                          ) : file.fileType.toLowerCase().includes("pdf") ? (
                            <a href={file.fileUrl} target="_blank">
                              <PictureAsPdfOutlinedIcon
                                className={"uploadImageCmpIconPDFReply"}
                                // style={{ marginTop: "1vh" }}
                              />
                            </a>
                          ) : file.fileType.toLowerCase().includes("zip") ? (
                            <a href={file.fileUrl} target="_blank">
                              <FolderZipOutlinedIcon
                                className={"uploadImageCmpIconPDFReply"}
                                // style={{ marginTop: "1vh" }}
                              />
                            </a>
                          ) : (
                            <a href={file.fileUrl} target="_blank">
                              <InsertDriveFileOutlinedIcon
                                className={"uploadImageCmpIconPDFReply"}
                                // style={{ marginTop: "1vh" }}
                              />
                            </a>
                          )
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                {Thunmbnail && (
                  <Grid item xs={12} paddingLeft={"1rem"} paddingRight={"1rem"}>
                    <div
                      style={{
                        width: "120px",
                        height: "100px",
                        marginTop: "10px",
                      }}
                    >
                      <img
                        onClick={() => {
                          openInNewTab(Thunmbnail);
                        }}
                        alt=""
                        src={Thunmbnail[0].preview}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
              xs={12}
              sx={{ background: "#fff", borderRadius: "5px" }}
            >
              <Grid item xs={10} style={{ fontSize: "14px" }}>
                <MentionsInput
                  style={{
                    background: "#fff",
                    // width: "350px",
                    // height: "50px",
                    border: "none",
                    borderRadius: "5px",
                    maxHeight: "180px",

                    // overflowY: "auto",
                  }}
                  onKeyDown={(e: any) =>
                    e.key === "Enter" ? handleReply() : ""
                  }
                  value={comment}
                  onChange={(event) => {
                    setComment(event.target.value);
                    if (event.target.value !== "") {
                      setTyping(true);
                    } else {
                      setTyping(false);
                    }
                  }}
                  className="mentions"
                  // classNames={Style}
                  placeholder="متن پیگیری ..."
                  allowSuggestionsAboveCursor={true}
                >
                  <Mention
                    appendSpaceOnAdd={true}
                    className="mentionedUsers"
                    data={mentionUsers}
                    trigger="@"
                    displayTransform={(id, display) => `@ ${display}`}
                    renderSuggestion={(
                      suggestion,
                      search,
                      highlightedDisplay,
                      index,
                      focused
                    ) => (
                      <div>
                        {suggestion.id.toString().search(/female/i) !== -1 ? (
                          <img
                            src="/images/person_3_black_24dp.svg"
                            alt="avatar"
                            className="mentions-avatar"
                          />
                        ) : (
                          <img
                            src="/images/person_black_24dp.svg"
                            alt="avatar"
                            className="mentions-avatar"
                          />
                        )}
                        {highlightedDisplay}
                      </div>
                    )}
                    // onAdd={(e) =>
                    //   typeof e === "string"
                    //     ? setMentionedUserIds([
                    //         ...mentionedUserIds,
                    //         Number(e.split("/")[0]),
                    //       ])
                    //     : null
                    // }
                  />
                </MentionsInput>
              </Grid>
              {!isTyping && (
                <Grid
                  item
                  xs={1}
                  sx={{ cursor: "pointer" }}
                  // onClick={() =>
                  //   // setAttachmentDrawer(true)
                  //   fileReplyInput.current?.click()
                  // }
                  style={{ background: "#fff" }}
                >
                  {/* <input
                    type="file"
                    style={{ display: "none" }}
                    ref={fileReplyInput}
                    onChange={(e) => {
                      setThunmbnail(URL.createObjectURL(e.target.files![0]));
                    }}
                  /> */}
                  {/* <AttachmentIcon fontSize="large" sx={{ color: "black" }} /> */}
                  <DropzoneCommentReply
                    refDropZone={fileReplyInput}
                    onFileChoosed={handleOnImageChoosed}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={1}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setReply(true);
                  setOpen(false);
                  handleSendMessage();
                }}
                style={{ background: "#fff" }}
              >
                <SendIcon
                  style={{ rotate: "180deg" }}
                  sx={{ color: "black" }}
                  fontSize="large"
                />
              </Grid>
              {/* <Grid item xs={2}></Grid> */}
            </Grid>
          </Grid>
          {/* <AttachmentDrawer
            attachmentDrawer={attachmentDrawer}
            setAttachmentDrawer={setAttachmentDrawer}
            referenceKey={referenceKey}
            mentionUsers={mentionUsers}
          /> */}
        </div>
      )}
    </>
  );
}
